import type React from 'react';

import { ProgressBar, Text } from '@change/ds-core-ui';
import { TrendingIcon } from '@change/ds-icons';

import { TranslateHtml, useI18n } from '@change-corgi/core-react/i18n';

import type { CloseToGoalCardData } from '../../hooks/usePetitionMarquee';
import { CardWrapper } from '../CardWrapper';

type Props = Readonly<{
	petition: CloseToGoalCardData;
	onClick: () => void;
	duplicate?: boolean;
}>;

export const CloseToGoalCard: React.FC<Props> = ({ petition, onClick, duplicate = false }) => {
	const { translate } = useI18n();

	return (
		<CardWrapper
			cardKey={petition.key}
			href={petition.href}
			onClick={onClick}
			duplicate={duplicate}
			icon={TrendingIcon}
			label={translate('corgi.components.petition_card.momentum_badge.close_to_goal')}
			trailingLabel={petition.relativeTimeLabel}
		>
			<Text as="span" className="text-typography-strong line-clamp-2">
				<TranslateHtml
					value="corgi.homepage.petition_marquee.close_to_goal_body"
					// the title as a JSX replacement so it lands as a React child (escaped) - a string
					// replacement is interpolated before the HTML parse and would be read as markup
					replacements={{ title: <>{petition.title}</>, goal: petition.goalSignaturesLabel }}
				/>
			</Text>
			<div className="mt-2 flex items-center gap-2">
				<div className="min-w-0 flex-1">
					<ProgressBar
						ariaLabel={translate('corgi.homepage.petition_marquee.goal_progress_label')}
						percentage={petition.goalPercent}
					/>
				</div>
				<Text as="span" variant="body" size="x-small" className="text-typography-weak shrink-0">
					{petition.goalPercentLabel}
				</Text>
			</div>
		</CardWrapper>
	);
};
